export default __webpack_public_path__ + "static/listing-page-c14b8f8ebcaf65c37b41ac2a0a9bbea4.png";